import { apiGet, apiPatch } from "./client";

export type DocSeries = {
  docType: string;
  mode: "auto" | "manual" | "manual_prefilled";
  prefix: string;
  padWidth: number;
  nextSeq: number;
  suggested: string;
};

export function getDocSeries(companyRef: string, docType: string) {
  return apiGet<{ series: DocSeries }>(
    `/c/${companyRef}/doc-series/${docType}`,
  );
}

export function updateDocSeries(
  companyRef: string,
  docType: string,
  body: {
    mode?: "auto" | "manual" | "manual_prefilled";
    prefix?: string;
    padWidth?: number;
  },
) {
  return apiPatch<{ series: DocSeries }>(
    `/c/${companyRef}/doc-series/${docType}`,
    body,
  );
}
